import type { ImAccount } from '@fruitful/types';

import { useGetApexAccounts } from '../../../investment/hooks/useGetApexAccounts';

export const useInternalInvestmentAccountsForIncomeSplit = (): {
    internalInvestmentAccounts: ImAccount[];
    isLoading: boolean;
} => {
    const { data: apexAccounts, isLoading: isLoadingApex } =
        useGetApexAccounts();

    return {
        internalInvestmentAccounts: apexAccounts ?? [],
        isLoading: isLoadingApex,
    };
};
